// import Config from '../utilities/Config.js';
import serializeObject from '../utilities/serializeObject.js';
import closestParent from '../utilities/closestParent.js';
import delegateEvent from '../utilities/delegateEvent.js';
// import axios from 'axios'; // @todo do without axios
import ImagesLoaded from './ImagesLoaded.js';

export default function ItemList() {
  const options = {
    selectors: {
      namespace: '.w-b-item-list',
      container: '.w-b-item-list[data-w-list-ajax="1"]',
      content: '.w-b-item-list__items',
      paginationTrigger: '[data-w-list-pagination]',
    },
    classes: {
      loading: 'w-is-loading',
      loadMore: 'w-is-loading-more',
      hidden: 'tw-hidden',
      proxyHidden: 'w-is-hidden',
    },
    dataAttributePrefix: 'data-w-list-',
    dataAttributes: {
      pagination: 'pagination',
    },
    debug: false,
  };

  const loadData = function (type, list) {
    let url = list.getAttribute(options.dataAttributePrefix + 'ajax-url');
    if (!url) return;

    const form = list.getElementsByTagName('form')[0];
    const method =
      form && form.length > 0 ? form.getAttribute('method') : 'GET';
    let data =
      type === 'reset_filters' || !form || form.length === 0
        ? {}
        : serializeObject(form);

    const filterToggle = list.querySelector(
      options.selectors.namespace + '__filter-toggle'
    );
    const content = list.querySelector(options.selectors.content);
    const nothingFoundText = list.querySelector(
      options.selectors.namespace + '__nothing-found'
    );
    const pagingPrevious = list.querySelector(
      '[' +
        options.dataAttributePrefix +
        options.dataAttributes.pagination +
        '="previous"]'
    );
    const pagingNext = list.querySelector(
      '[' +
        options.dataAttributePrefix +
        options.dataAttributes.pagination +
        '="next"]'
    );
    const pagingMore = list.querySelector(
      '[' +
        options.dataAttributePrefix +
        options.dataAttributes.pagination +
        '="more"]'
    );
    /*
    const $resetFilters = $list
        .find(moduleSelector + '__reset_filters')
        .first();
    */

    const attributePrefix = list.getAttribute(
      options.dataAttributePrefix + 'attribute-prefix'
    );
    const currentPage = parseInt(
      list.getAttribute(options.dataAttributePrefix + 'current-page')
    );
    const totalPages = parseInt(
      list.getAttribute(options.dataAttributePrefix + 'total-pages')
    );
    let targetPage = 1;

    if (type === 'previous') {
      if (currentPage <= 1) {
        if (options.debug) console.error('Invalid target page.');
        return;
      }

      targetPage = currentPage - 1;

      data[attributePrefix + 'page'] = targetPage;
    } else if (type === 'next' || type === 'more') {
      if (currentPage >= totalPages) {
        if (options.debug) console.error('Invalid target page.');
        return;
      }

      targetPage = currentPage + 1;

      data[attributePrefix + 'page'] = targetPage;
    }

    list.setAttribute(options.dataAttributePrefix + 'current-page', targetPage);
    list.classList.add(options.classes.loading);

    if (filterToggle) filterToggle.classList.add(options.classes.loading);
    document.documentElement.classList.add(options.classes.loading);

    let fetchUrl = new URL(url);
    Object.keys(data).forEach((key) =>
      fetchUrl.searchParams.append(key, data[key])
    );

    fetch(fetchUrl, {
      method,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then((response) => response.json())
      .then((response) => {
        // @deprecated globalResponsiveBackgroundStyles
        // if (response.items_style) {
        //   const styleElement = document.getElementById(
        //     options.ids.globalResponsiveBackgroundStyles
        //   );
        //   const style = styleElement.innerHTML + response.items_style;
        //   if (debug) style = '/* ' + url + ' */' + style;
        //   styleElement.innerHTML = style;
        // }

        if (response.items_html.length > 0) {
          const responseContent = response.items_html;
          if (type === 'more') {
            responseContent.forEach((item, index) => {
              const container = document.createElement('div');
              container.innerHTML = item;
              const element = container.firstElementChild;
              element.classList.add(options.classes.proxyHidden);
              content.append(element);

              setTimeout(() => {
                element.classList.remove(options.classes.proxyHidden);
              }, 10 * (index + 1));
            });
          } else {
            content.innerHTML = responseContent.join('');
          }
          nothingFoundText.classList.add(options.classes.hidden);

          if (pagingPrevious) {
            if (response.current_page > 1)
              pagingPrevious.classList.remove(options.classes.hidden);
            else pagingPrevious.classList.add(options.classes.hidden);
          }
          if (pagingNext) {
            if (response.current_page < response.total_pages)
              pagingNext.classList.remove(options.classes.hidden);
            else pagingNext.classList.add(options.classes.hidden);
          }
          if (pagingMore) {
            if (response.current_page < response.total_pages)
              pagingMore.classList.remove(options.classes.hidden);
            else pagingMore.classList.add(options.classes.hidden);
          }
        } else {
          content.innerHTML = '';
          nothingFoundText.classList.remove(options.classes.hidden);
          if (pagingPrevious)
            pagingPrevious.classList.add(options.classes.hidden);
          if (pagingNext) pagingNext.classList.add(options.classes.hidden);
        }

        if (filterToggle)
          filterToggle.classList.remove(options.classes.loading);
        document.documentElement.classList.remove(options.classes.loading);

        // if (response.has_filters_set)
        //     resetFilters.classList.remove(options.classes.hidden);
        // else resetFilters.classList.add(options.classes.hidden);

        list.setAttribute(
          options.dataAttributePrefix + 'has-filter-set',
          response.has_filters_set ? '1' : '0'
        );
        list.setAttribute(
          options.dataAttributePrefix + 'total-pages',
          response.total_pages
        );
        list.setAttribute(
          options.dataAttributePrefix + 'results-count',
          response.results_count
        );
      })
      .catch((errorThrown) => {
        if (options.debug) console.error(errorThrown);

        nothingFoundText.classList.remove(options.classes.hidden);
        if (pagingPrevious)
          pagingPrevious.classList.add(options.classes.hidden);
        if (pagingNext) pagingNext.classList.add(options.classes.hidden);
      })
      .finally(() => {
        setTimeout(() => {
          list.classList.remove(options.classes.loading);

          const imagesLoaded = ImagesLoaded();
          imagesLoaded.init();
        }, 100);

        // const event = new CustomEvent('w.updateinview');
        // document.dispatchEvent(event);
      });
  };

  const setup = function () {
    // filter & sort
    delegateEvent(
      document,
      'submit',
      options.selectors.namespace + '__form',
      function (event) {
        event.preventDefault();

        loadData(
          'filter',
          closestParent(event.target, options.selectors.container)
        );
      }.bind(this)
    );

    // reset filters
    // $lists.on('click', moduleSelector + '__reset_filters', function(e) {
    //     e.preventDefault();

    //     // reset UI (deselect checkboxes, set select to first entry, remove text from inputs/textareas)
    //     resetInputs($lists.find('input[type="checkbox"], select'));

    //     loadData('reset_filters', $(this).closest(moduleSelector));
    // });

    // paging
    document.addEventListener('click', (event) => {
      const target = closestParent(
        event.target,
        options.selectors.container + ' ' + options.selectors.paginationTrigger
      );
      if (target) {
        event.preventDefault();

        const type = target.getAttribute(
          options.dataAttributePrefix + options.dataAttributes.pagination
        );

        loadData(
          type,
          closestParent(event.target, options.selectors.container)
        );
      }
    });

    delegateEvent(
      document,
      'change',
      options.selectors.namespace +
        '__form select, ' +
        options.selectors.namespace +
        '__form input[type="radio"], ' +
        options.selectors.namespace +
        '__form input[type="checkbox"]',
      function (event, element) {
        event.preventDefault();

        // const list = closestParent(element, options.selectors.namespace);
        // list.classList.remove('w-is-filter-open');
        // document.documentElement.classList.remove('w-has-filter-open');

        // const filterItems = list.querySelectorAll(
        //   options.selectors.namespace + '__form .w-radio',
        //   options.selectors.namespace + '__form .w-radio'
        // );
        // filterItems.forEach(function (item) {
        //   item.classList.remove('w-is-checked');
        // });
        // element.parentElement.classList.add('w-is-checked');

        loadData(
          'filter',
          closestParent(event.target, options.selectors.container)
        );
      }.bind(this)
    );

    let timeoutId;
    delegateEvent(
      document,
      'keyup',
      options.selectors.namespace + '__form input[type="text"]',
      function (event, element) {
        event.preventDefault();

        clearTimeout(timeoutId);

        timeoutId = setTimeout(() => {
          loadData(
            'filter',
            closestParent(event.target, options.selectors.container)
          );
        }, 1000);
      }.bind(this)
    );

    // delegateEvent(
    //   document,
    //   'click',
    //   options.selectors.namespace + '__form .w-radio__overlay',
    //   function (event, element) {
    //     event.preventDefault();
    //     const filterItems = closestParent(
    //       element,
    //       '.w-b-radio-list-filter__items'
    //     );
    //     filterItems.children[0].querySelector('input').click();
    //   }.bind(this)
    // );

    delegateEvent(
      document,
      'click',
      '[data-w-list-filter-toggle]',
      (event, element) => {
        event.preventDefault();
        const filter = closestParent(element, options.selectors.namespace);
        filter.classList.add('w-is-filter-open');
        document.documentElement.classList.add('w-has-filter-open');
      }
    );

    delegateEvent(
      document,
      'click',
      '[data-w-list-filter-close]',
      (event, element) => {
        event.preventDefault();
        const filter = closestParent(element, options.selectors.namespace);
        filter.classList.remove('w-is-filter-open');
        document.documentElement.classList.remove('w-has-filter-open');
      }
    );
  };

  return {
    init: () => {
      setup();
    },
  };
}
